import { RootState } from '../store'
export const selectRisques = (state: RootState) => state.risque.risques
export const selectLoading = (state: RootState) => state.risque.loading
export const selectError = (state: RootState) => state.risque.error
export const selectActionsDistribution = (state: RootState) =>
  state.risque.actionsDistribution
export const selectRelatedRisks = (state: RootState) =>
  state.risque.relatedRisks

export const selectRelatedRisksLoading = (state: RootState) =>
  state.risque.loading

export const selectRelatedRisksError = (state: RootState) => state.risque.error
